var divider_viewer_rtlignore_default = {
  "divider-container": "KMBvr",
  "divider-container--double": "wJ3Mg",
  "divider": "skvB6",
  "divider--single": "_1iuSc",
  "divider--double": "WlvJS",
  "divider--dashed": "nsP4h",
  "divider--dotted": "jAO8R",
  "divider--small": "WJBpu",
  "divider--medium": "phST-",
  "divider--large": "_5EB8w",
  "divider--left": "ZsYjW",
  "divider--center": "H5S99",
  "divider--right": "gG4oD",
  "svgFixerContainer": "BHCi0",
  "emptyChar": "-rVLb"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
